import { URL_GET_CANTAB } from 'constants/urls';

const getCanTabApi = async () => {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_CANTAB, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
};

export default getCanTabApi;
